import { useState } from 'react';
import ZipDropzone from './zip-dropzone';
import ZipPlacementPicker, { SignaturePlacement } from './zip-placement-picker';
import { SignZipModal } from './sign-zip-modal';
import styles from './sign-zip.module.scss';

type Stage = 'upload' | 'placement'; // | 'sign';

export default function SignZip() {
	const [stage, setStage] = useState<Stage>('upload');
	const [zipFile, setZipFile] = useState<File | null>(null);
	const [placement, setPlacement] = useState<SignaturePlacement>();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleFileSelected = (file: File) => {
		setZipFile(file);
		setStage('placement');
	};

	const handlePlacementConfirmed = (
		signaturePlacement?: SignaturePlacement,
	) => {
		if (signaturePlacement) setPlacement(signaturePlacement);

		setIsModalOpen(true);
	};

	const handleBack = () => {
		if (stage === 'placement') {
			setStage('upload');
			setZipFile(null);
		}
	};

	return (
		<div
			className={
				styles['sign-zip-container'] + ' cyber-main with-sidenav'
			}
		>
			<div className="cyber-spacer section" />
			<div className={styles['sign-zip']}>
				{stage === 'upload' ? (
					<ZipDropzone onFileSelected={handleFileSelected} />
				) : stage === 'placement' && zipFile ? (
					<ZipPlacementPicker
						zipFileName={zipFile.name}
						onConfirm={handlePlacementConfirmed}
						onBack={handleBack}
					/>
				) : null}

				{zipFile && (
					<SignZipModal
						zipFile={zipFile}
						placement={placement}
						isOpen={isModalOpen}
						onOpen={() => setIsModalOpen(true)}
						onClose={() => setIsModalOpen(false)}
					/>
				)}
			</div>
		</div>
	);
}
